module.exports = __webpack_public_path__ + "static/community-4-90a8b18ff177d862991ea8cc7a1de011.png";